<div class="general cycle__child spacing--padding-all spacing--margin-all" data-test="general">
  <form [formGroup]="form" (ngSubmit)="save()">
    <div class="flex--column">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'cycle.cycle-number' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          placeholder="{{ 'cycle.cycle-number' | translate }}"
          formControlName="cycleNumber"
          data-test="general__couple-number"
        />
        <mat-error *ngIf="form.controls.cycleNumber.invalid">
          {{ 'cycle.error-cycle-number' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'cycle.description' | translate }}</mat-label>
        <textarea
          matInput
          placeholder="{{ 'cycle.description' | translate }}"
          formControlName="description"
          data-test="general__description"
        >
        </textarea>
      </mat-form-field>

      <div class="observation-settings">
        <h6 class="text--h6">{{ 'observation-settings.title' | translate }}</h6>
        <span class="float-left">
          <a
            [routerLink]=""
            mat-link-button
            (click)="openObservationsettings()"
            data-test="general__open_observation-settings"
          >
            {{ 'observation-settings.open-settings' | translate }}
          </a>
        </span>
      </div>

      <div class="spacing--margin-top mat-button-row">
        <button
          type="submit"
          mat-flat-button
          class="flex__child"
          color="primary"
          data-test="general__save"
        >
          {{ 'save' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
